import { Users } from 'lucide-react';
import { cn } from '@/lib/cn';
import { hashColor, initials } from '@/lib/avatar';

export interface AvatarProps {
  name?: string | null;
  src?: string | null;
  /** Si es un grupo: sin imagen, muestra un icono de personas. */
  isGroup?: boolean;
  /** Semilla para el color (jid/externalId). Cae al nombre si falta. */
  seed?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'h-8 w-8 text-xs', // 32px
  md: 'h-10 w-10 text-sm', // 40px
  lg: 'h-14 w-14 text-lg', // 56px
} as const;

const iconSizes = { sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-7 w-7' } as const;

/**
 * Avatar inteligente: imagen si hay `src`; si no, iniciales (o icono de grupo)
 * sobre un fondo coloreado de forma estable por la identidad (`seed`/nombre).
 */
export function Avatar({ name, src, isGroup = false, seed, size = 'md', className }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name ?? 'avatar'}
        className={cn('shrink-0 rounded-full object-cover', sizes[size], className)}
      />
    );
  }

  const bg = hashColor(seed ?? name);
  return (
    <span
      style={{ backgroundColor: bg }}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white',
        sizes[size],
        className,
      )}
    >
      {isGroup ? <Users className={iconSizes[size]} /> : initials(name)}
    </span>
  );
}
